module.exports = __webpack_public_path__ + "static/media/2.b9612b8a.svg";